import { render, staticRenderFns } from "./EditIcon.vue?vue&type=template&id=1c98b6f4&scoped=true&"
import script from "./EditIcon.vue?vue&type=script&lang=js&"
export * from "./EditIcon.vue?vue&type=script&lang=js&"
import style0 from "./EditIcon.vue?vue&type=style&index=0&id=1c98b6f4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c98b6f4",
  null
  
)

export default component.exports